import PropTypes from 'prop-types';

// Badge de estado de SLA en la cola. No renderiza nada cuando el ticket esta
// dentro de plazo (sla = null): solo se destaca lo accionable (vencido / por
// vencer). El objeto sla lo calcula slaEstado() a partir de vence_sla_en.
const SlaBadge = ({ sla }) => {
  if (!sla) return null;
  return (
    <span className={`tickets-badge tickets-sla tickets-sla--${sla.nivel}`}>{sla.label}</span>
  );
};

SlaBadge.propTypes = {
  sla: PropTypes.shape({
    nivel: PropTypes.oneOf(['vencido', 'porvencer']).isRequired,
    label: PropTypes.string.isRequired,
  }),
};

SlaBadge.defaultProps = {
  sla: null,
};

export default SlaBadge;
